import { render, staticRenderFns } from "./UpdateCardModal.vue?vue&type=template&id=32366ef4&scoped=true&"
import script from "./UpdateCardModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32366ef4",
  null
  
)

export default component.exports